<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Users'"></span>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            to="/users/create"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            :to="`/users/upload/${this.$route.params.courseId}`"
          >
            <v-icon dark> mdi-upload </v-icon>
          </v-btn>
          <v-alert
            v-if="isMasterUser()"
            type="info"
            dense
            outlined
            class="ml-4"
            style="display: inline-block"
          >
            Showing candidates from your vessel only
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-row>
                <v-col md="3">
                  <v-text-field
                    v-model="search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    @keydown.enter="getData"
                    @change="page = 1"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col md="2">
                  <v-autocomplete
                    ref="roleFilter"
                    v-model="form.role_id"
                    :items="roleOptions"
                    label="Filter by Role"
                    @change="(page = 1), getData()"
                    prepend-icon="mdi-account-group"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col md="2">
                  <v-autocomplete
                    ref="rankFilter"
                    v-model="form.rank"
                    :items="ranks"
                    label="Filter by Rank"
                    @change="
                      page = 1;
                      getData();
                    "
                    prepend-icon="mdi-account-card-details"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col md="2">
                  <v-autocomplete
                    ref="vesselFilter"
                    v-model="form.vessel_id"
                    :items="vessels"
                    item-text="text"
                    item-value="value"
                    label="Filter by Vessel"
                    @change="
                      page = 1;
                      getData();
                    "
                    prepend-icon="mdi-ferry"
                    clearable
                    :disabled="isMasterUser()"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-if="roleName == 'SUPER ADMIN' || roleName == 'ADMIN' || roleName == 'MANAGER'"
                  sm="3"
                >
                  <v-autocomplete
                    ref="Teachers"
                    v-model="teacher_id"
                    :items="Teachers"
                    label="Teachers"
                    @change="(page = 1), getData()"
                    prepend-icon="mdi-account"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    v-model="form.active"
                    :items="statuses"
                    label="Status"
                    @change="(page = 1), getData()"
                    prepend-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col md="4">
                  <v-pagination
                    v-model="page"
                    circle
                    :length="paginationLength"
                    :total-visible="7"
                  >
                  </v-pagination>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-title v-if="users.length != 0">
              <v-spacer></v-spacer>
              <v-btn class="primary mx-4" @click="generateExcel()">
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Role</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                    <th class="text-left">Rank</th>
                    <th class="text-left">Vessel</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="users.length != 0">
                  <tr v-for="(user, i) in users" :key="`user${i}`">
                    <td style="min-width: 85px">
                      <!-- Offline candidate indicators -->
                      <v-tooltip
                        bottom
                        v-if="user.is_offline && user.sync_status === 'pending'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="orange"
                          >
                            mdi-wifi-off
                          </v-icon>
                        </template>
                        <span>Offline - Pending Sync</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-else-if="
                          user.is_offline && user.sync_status === 'synced'
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="secondary"
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                        <span>Synced Successfully</span>
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        v-else-if="
                          user.is_offline && user.sync_status === 'failed'
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>Sync Failed</span>
                      </v-tooltip>

                      <!-- Regular online candidate indicators -->
                      <v-tooltip bottom v-else-if="user.active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Candidate is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Candidate is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ serialNoStarting + i + 1 }}
                    </td>
                    <td>{{ user.roles[0] ? user.roles[0].name : "" }}</td>
                    <td>{{ user.name || "" }}</td>
                    <td>{{ user.email || "" }}</td>
                    <td>{{ user.phone || "" }}</td>
                    <td>{{ user.rank || "" }}</td>
                    <td>{{ getVesselName(user.vessel_id) || "" }}</td>
                    <td class="text-center">
                      <v-tooltip bottom v-if="user.active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>User is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>User is InActive</span>
                      </v-tooltip>
                    </td>
                    <td class="text-center" style="white-space: nowrap; min-width: 110px">
                      <div
                        style="
                          display: inline-flex;
                          gap: 10px;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <v-btn
                          fab
                          x-small
                          color="primary"
                          :to="`/users/${user.id}`"
                        >
                          <v-icon dark> mdi-pencil </v-icon>
                        </v-btn>
                        <v-btn
                          v-if="
                            roleName == 'MANAGER' &&
                            user.roles &&
                            user.roles[0] &&
                            user.roles[0].name == 'CANDIDATE'
                          "
                          fab
                          x-small
                          color="error"
                          @click="openDeleteDialog(user)"
                        >
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- Delete candidate dialog (MANAGER only) -->
      <v-dialog v-model="deleteDialog" max-width="520" persistent>
        <v-card>
          <v-card-title class="text-h6 error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            Delete Candidate
          </v-card-title>
          <v-card-text>
            <p class="mb-3">
              You are about to delete
              <strong>{{
                deleteTarget ? deleteTarget.name || deleteTarget.email : ""
              }}</strong>. This removes the candidate from the software. A reason
              is required and will be recorded for audit.
            </p>
            <v-textarea
              v-model="deleteReason"
              label="Reason for deletion *"
              outlined
              auto-grow
              rows="3"
              :error-messages="deleteError"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDeleteDialog" :disabled="isDeleting">
              Cancel
            </v-btn>
            <v-btn color="error" @click="confirmDelete" :loading="isDeleting">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import UserDataService from "@/services/user-data-service";
import axios from "axios";

export default {
  name: "UsersPage",
  computed: {
    roleName() {
      return this.$store.getters["auth/roleName"];
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      form: {
        active: "",
        role_id: 4, // Default to showing only candidates (role_id = 4)
        rank: "",
        vessel_id: "",
      },
      page: 1,
      rowsPerPage: 10, // Items per page for pagination
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      users: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      Teachers: [
        {
          id: 0,
          text: "Select Teacher",
          value: "",
        },
      ],
      ranks: [
        {
          id: 0,
          text: "Select Rank",
          value: "",
        },
      ],
      vessels: [
        {
          id: 0,
          text: "Select Vessel",
          value: "",
        },
      ],
      isLoading: false,
      isExcelloading: false,
      // Delete candidate dialog state (MANAGER only)
      deleteDialog: false,
      deleteTarget: null,
      deleteReason: "",
      deleteError: "",
      isDeleting: false,
      teacher_id: "",
      ExportUsers: [],
      Export_users: [],
      roleOptions: [
        {
          id: 0,
          text: "All Roles",
          value: "",
        },
        { id: 1, text: "SUPER ADMIN", value: 1 },
        { id: 2, text: "ADMIN", value: 2 },
        { id: 3, text: "TEACHER", value: 3 },
        { id: 4, text: "CANDIDATE", value: 4 },
        { id: 5, text: "COMPANY", value: 5 },
        { id: 6, text: "MANAGER", value: 6 },
      ],
      vesselData: [], // To store vessel data for lookup
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
    this.getMasters();
    // Check if user is MASTER and set vessel filter automatically
    this.checkMasterVesselFilter();
  },
  methods: {
    isMasterUser() {
      return (
        this.currentUser &&
        (this.currentUser.rank === "MASTER" ||
          this.currentUser.rank === "VESSEL ADMIN") &&
        this.currentUser.vessel_id
      );
    },
    checkMasterVesselFilter() {
      // Check if user is MASTER and has vessel_id
      if (this.isMasterUser()) {
        // Automatically set vessel filter for MASTER users
        this.form.vessel_id = this.currentUser.vessel_id;
        // Also restrict to candidates only
        this.form.role_id = 4;
      }
    },
    async getMasters() {
      try {
        // Get user data (teachers and created_by)
        let usersResponse = await axios.get(`users/masters`);
        let usersData = usersResponse.data?.data || {};

        // Clear existing data
        this.Teachers = [
          {
            id: 0,
            text: "Select Teacher",
            value: "",
          },
        ];

        // Populate teachers dropdown
        if (usersData.teachers && Array.isArray(usersData.teachers)) {
          usersData.teachers.forEach((teacher) => {
            if (teacher && teacher.id && teacher.name) {
              this.Teachers.push({
                id: teacher.id,
                text: teacher.name,
                value: teacher.id,
              });
            }
          });
        }

        // Get value lists data (vessels, ranks, subjects, etc.)
        let valueListsResponse = await axios.get(`value_lists/showAll`);
        let rawData = valueListsResponse.data?.data || [];

        // Group data by category (value_id)
        let masters = {
          vessels: rawData.filter((item) => item.value_id === 6),
          ranks: rawData.filter((item) => item.value_id === 1),
          subjects: rawData.filter((item) => item.value_id === 3),
          duration: rawData.filter((item) => item.value_id === 2),
          nationality: rawData.filter((item) => item.value_id === 4),
          birth_place: rawData.filter((item) => item.value_id === 5),
        };

        console.log("Value lists data loaded:", masters);

        // Populate ranks dropdown
        this.ranks = [
          {
            id: 0,
            text: "Select Rank",
            value: "",
          },
        ];

        if (masters.ranks && Array.isArray(masters.ranks)) {
          masters.ranks.forEach((rank) => {
            if (rank && rank.id && rank.description) {
              this.ranks.push({
                id: rank.id,
                text: rank.description,
                value: rank.description,
              });
            }
          });
        }

        // Populate vessels dropdown
        this.vessels = [
          {
            id: 0,
            text: "Select Vessel",
            value: "",
          },
        ];

        if (masters.vessels && Array.isArray(masters.vessels)) {
          console.log("Vessels data loaded:", masters.vessels);
          masters.vessels.forEach((vessel) => {
            if (vessel && vessel.id && vessel.description) {
              this.vessels.push({
                id: vessel.id,
                text: vessel.description,
                value: vessel.id,
              });
            }
          });
          // Store vessel data for lookup
          this.vesselData = masters.vessels;
          console.log("Vessel data stored for lookup:", this.vesselData);
        }

        console.log(
          "Candidate listing: Teachers loaded:",
          this.Teachers.length - 1,
          "Ranks loaded:",
          this.ranks.length - 1,
          "Vessels loaded:",
          this.vessels.length - 1
        );
      } catch (error) {
        console.error("Candidate listing: Error loading master data:", error);
        this.Teachers = [
          {
            id: 0,
            text: "Select Teacher",
            value: "",
          },
        ];
        this.ranks = [
          {
            id: 0,
            text: "Select Rank",
            value: "",
          },
        ];
        this.vessels = [
          {
            id: 0,
            text: "Select Vessel",
            value: "",
          },
        ];
      }
    },
    getVesselName(vesselId) {
      if (!vesselId) return "";
      const vessel = this.vesselData.find((v) => v.id == vesselId);
      return vessel ? vessel.description : "";
    },
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.form.active = this.form.active ? this.form.active : "";
      this.teacher_id = this.teacher_id ? this.teacher_id : "";
      this.form.rank = this.form.rank ? this.form.rank : "";

      // For MASTER users, always use their vessel_id
      let vesselId = this.form.vessel_id || null;
      if (this.isMasterUser()) {
        vesselId = this.currentUser.vessel_id;
        // Also restrict to candidates only
        this.form.role_id = 4;
      }

      const filters = {
        roleId: this.form.role_id || null, // Use selected role or null for all
        search: this.search_keyword,
        active: this.form.active !== "" ? this.form.active === "1" : null,
        page: this.page,
        limit: this.rowsPerPage,
        rank: this.form.rank || null,
        vessel_id: vesselId,
      };

      console.log("User listing filters:", filters);

      try {
        let response = await UserDataService.getUsers(filters);
        this.users = response.data || [];
        this.count = response.count || this.users.length;

        // If in offline mode, merge with offline candidate storage similar to courses
        if (window.electron && this.form.role_id === 4) {
          // Only for candidates
          try {
            const { offlineCandidateStorage } = await import(
              "@/services/offline-candidate-storage"
            );

            // First, get updated candidates and merge them with existing data
            const updatedCandidates =
              await offlineCandidateStorage.getAllUpdatedCandidates();
            if (updatedCandidates.length > 0) {
              // Replace existing users with updated versions
              this.users = this.users.map((user) => {
                const updatedCandidate = updatedCandidates.find(
                  (updated) =>
                    updated.original_id &&
                    updated.original_id.toString() === user.id.toString()
                );
                return updatedCandidate || user;
              });
              console.log(
                "Offline mode: Merged",
                updatedCandidates.length,
                "updated candidates"
              );
            }

            // Then add purely offline-created candidates
            const offlineCandidates =
              await offlineCandidateStorage.getAllOfflineCandidates();
            const newOfflineCandidates = offlineCandidates.filter(
              (candidate) => !candidate.is_updated
            );

            // Add offline candidates to the list with visual indicators
            const enrichedOfflineCandidates = newOfflineCandidates.map(
              (candidate) => ({
                ...candidate,
                name: candidate.name + " (Offline)",
                is_offline: true,
                sync_status: candidate.sync_status || "pending",
                roles: [{ id: 4, name: "CANDIDATE" }], // Ensure role structure
                active: candidate.active !== false, // Default to active for offline candidates
              })
            );

            this.users = [...this.users, ...enrichedOfflineCandidates];
            this.count += enrichedOfflineCandidates.length;
          } catch (error) {
            console.error("Failed to load offline candidates:", error);
          }
        }

        this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
        this.paginationLength = Math.ceil(this.count / this.rowsPerPage);

        console.log(
          `Users loaded: ${this.users.length} of ${this.count} total`
        );
      } catch (error) {
        console.error("Error fetching user data:", error);
        this.users = [];
        this.count = 0;
        this.serialNoStarting = 0;
        this.paginationLength = 0;
      } finally {
        this.isLoading = false;
      }
    },
    async generateExcel() {
      this.isExcelloading = true;
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        (this.form.role_id || "") +
        "&rank=" +
        (this.form.rank || "") +
        "&vessel_id=" +
        (this.form.vessel_id || "");

      try {
        // Use the configured axios instance (in Electron this targets the local
        // Express server, which generates the xlsx and returns its URL).
        const response = await axios.get(`usersExports?${query}`);
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
      }
      this.isExcelloading = false;
    },
    // Stable, unique-per-browser id kept in localStorage. Lets the audit
    // distinguish two laptops even when they share one public IP.
    getOrCreateDeviceId() {
      try {
        let id = localStorage.getItem("sns_device_id");
        if (!id) {
          id =
            window.crypto && window.crypto.randomUUID
              ? window.crypto.randomUUID()
              : "dev-" +
                Math.random().toString(36).slice(2) +
                Date.now().toString(36);
          localStorage.setItem("sns_device_id", id);
        }
        return id;
      } catch (e) {
        return "unknown";
      }
    },
    // Short, readable browser + OS label from the User-Agent.
    describeClient() {
      const ua = navigator.userAgent || "";
      const m = ua.match(/(Edg|OPR|Chrome|Firefox|Safari)\/([\d.]+)/);
      const browser = m
        ? `${m[1] === "Edg" ? "Edge" : m[1]} ${m[2].split(".")[0]}`
        : "browser";
      const os = /Windows NT/.test(ua) ? "Windows" : navigator.platform || "OS";
      return `${browser} · ${os}`;
    },
    openDeleteDialog(user) {
      this.deleteTarget = user;
      this.deleteReason = "";
      this.deleteError = "";
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.deleteTarget = null;
      this.deleteReason = "";
      this.deleteError = "";
    },
    async confirmDelete() {
      if (!this.deleteReason || !this.deleteReason.trim()) {
        this.deleteError = "A reason is required to delete a candidate.";
        return;
      }
      this.isDeleting = true;
      this.deleteError = "";
      try {
        // Build a device descriptor for the audit trail.
        // - Desktop app: real machine hostname + Windows user.
        // - Web: a persistent per-browser Device ID (stable across sessions)
        //   plus browser/OS, because browsers cannot read the machine name.
        // The server records the IP independently, so it can't be faked away.
        const deviceId = this.getOrCreateDeviceId();
        let device = "";
        if (window.electron && window.electron.getDeviceInfo) {
          try {
            const info = await window.electron.getDeviceInfo();
            if (info) {
              device = `${info.hostname || ""} (user: ${
                info.username || "?"
              }${info.localIp ? ", ip: " + info.localIp : ""})`;
            }
          } catch (e) {
            console.warn("Could not read device info:", e);
          }
        }
        device = device
          ? `${device} | id:${deviceId}`
          : `id:${deviceId} · ${this.describeClient()}`;

        await axios.delete(`/users/${this.deleteTarget.id}`, {
          data: {
            reason: this.deleteReason.trim(),
            device: device,
          },
        });

        this.closeDeleteDialog();
        this.getData();
      } catch (e) {
        console.error("Error deleting candidate:", e);
        this.deleteError =
          (e.response && e.response.data && e.response.data.message) ||
          "Failed to delete candidate. Please try again.";
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
